import { useNavigate } from "react-router-dom";
import { ArrowLeft, MapPin, MessageCircle, Navigation } from "lucide-react";
import { Button } from "../components/ui/button";

const ADMIN_PHONE = "33753202093";

export const ShareLocationPage = () => {
  const navigate = useNavigate();

  const openWhatsAppLocation = () => {
    // Opens WhatsApp to share location natively via the app
    // On mobile: opens WhatsApp app with the admin number, user can then tap "+" > "Location" > "Share Live Location"
    const text = "Bonjour, je souhaite partager ma position en direct pour ma course YOUMI GREEN VTC.";
    window.location.href = `https://wa.me/${ADMIN_PHONE}?text=${encodeURIComponent(text)}`;
  };

  const openGoogleMapsSharing = () => {
    // Opens Google Maps app for live location sharing
    // On mobile: opens Google Maps where user can tap "Share location" 
    window.location.href = "https://maps.google.com/maps?q=my+location";
  };

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="px-4 py-4 border-b border-zinc-800">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-2 rounded-lg hover:bg-zinc-800 transition-colors" data-testid="back-btn">
            <ArrowLeft className="w-5 h-5 text-zinc-400" />
          </button>
          <MapPin className="w-5 h-5 text-red-400" />
          <h1 className="text-lg font-bold text-white font-['Outfit']">Partager ma position</h1>
        </div>
      </header>

      <main className="px-4 py-8 max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-emerald-500/15 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <MapPin className="w-10 h-10 text-emerald-400" />
          </div>
          <h2 className="text-xl font-bold text-white mb-2">Partagez votre position</h2>
          <p className="text-zinc-400 text-sm leading-relaxed">
            Envoyez votre position en direct a votre chauffeur via WhatsApp ou Google Maps.
          </p>
        </div>

        <div className="space-y-4">
          {/* WhatsApp - Primary */}
          <Button
            onClick={openWhatsAppLocation}
            className="w-full py-6 bg-[#25D366] hover:bg-[#1da851] text-white rounded-xl text-base font-semibold"
            data-testid="share-whatsapp-btn"
          >
            <MessageCircle className="w-6 h-6 mr-3" />
            Envoyer via WhatsApp
          </Button>

          <div className="text-center text-zinc-600 text-xs py-1">ou</div>

          {/* Google Maps */}
          <Button
            onClick={openGoogleMapsSharing}
            className="w-full py-6 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-base font-semibold"
            data-testid="share-gmaps-btn"
          >
            <Navigation className="w-6 h-6 mr-3" />
            Ouvrir Google Maps
          </Button>
        </div>

        {/* Instructions */}
        <div className="mt-10 space-y-4">
          <h3 className="text-white font-semibold text-sm">Comment partager en direct ?</h3>
          
          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-[#25D366]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                <MessageCircle className="w-4 h-4 text-[#25D366]" />
              </div>
              <div>
                <p className="text-white text-sm font-medium mb-1">Via WhatsApp</p>
                <ol className="text-zinc-400 text-xs space-y-1 list-decimal list-inside">
                  <li>Cliquez sur "Envoyer via WhatsApp"</li>
                  <li>Envoyez le message a votre chauffeur</li>
                  <li>Appuyez sur le <span className="text-white">+</span> en bas a gauche</li>
                  <li>Choisissez <span className="text-white">Position</span></li>
                  <li>Selectionnez <span className="text-white">Partager la position en direct</span></li>
                </ol>
              </div>
            </div>
          </div>

          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Navigation className="w-4 h-4 text-blue-400" />
              </div>
              <div>
                <p className="text-white text-sm font-medium mb-1">Via Google Maps</p>
                <ol className="text-zinc-400 text-xs space-y-1 list-decimal list-inside">
                  <li>Cliquez sur "Ouvrir Google Maps"</li>
                  <li>Appuyez sur votre <span className="text-white">point bleu</span> (votre position)</li>
                  <li>Selectionnez <span className="text-white">Partager la position</span></li>
                  <li>Envoyez le lien a votre chauffeur par WhatsApp</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* Contact footer */}
        <div className="mt-8 text-center">
          <p className="text-zinc-500 text-xs">Besoin d'aide ?</p>
          <a href="tel:+33753202093" className="text-emerald-400 text-sm font-medium" data-testid="call-driver-btn">
            Appeler le chauffeur : 07 53 20 20 93
          </a>
        </div>
      </main>
    </div>
  );
};
